import React from 'react';
import { FieldTitle } from './RedStarTitle';
import { LandingMediaDropbox } from './MediaDropBox';
import { faImage } from '@fortawesome/pro-solid-svg-icons';
import { BulletsInput } from './BulletsInput';
import { TextField } from '@client/new/components/basic';
import { Controller, useFormContext } from 'react-hook-form';
import { FieldDesc } from './common';
// import { Toggle } from '@client/components/common/inputs/Toggle';
// import { SelectImageSideInput } from './SelectImageSide';
import { TwoColumns } from '@client/new/pages/LandingPagesBuilder/layouts';
import CTAFormComponent from './CtaForm';

type Props = {
  index: number;
  upload: (f: File) => Promise<string>;
};
export const TextSection2 = ({ index, upload }: Props) => {
  const { register, control } = useFormContext();
  const r = (s: string) => register(`sections.${index}.${s}`);
  const MAX_DESC_LENGTH = 1300;

  const firstCol = (
    <>
      <div>
        <FieldTitle title={'Headline text'} />
        <div className="mb-[5px] max-w-[680px]">
          <TextField
            {...r(`title`)}
            className="w-full"
            inputProps={{
              placeholder: 'Headline text',
              maxLength: 60,
            }}
          />
        </div>
      </div>

      <div>
        <FieldTitle title={'Body Text'} />
        <FieldDesc>
          Body Text (new lines are preserved, max {MAX_DESC_LENGTH} characters)
        </FieldDesc>
        <div className="mb-[5px] max-w-[680px] w-full">
          <TextField
            {...r(`desc`)}
            multiline
            rows={5}
            className="w-full"
            inputProps={{
              style: { height: '200px' },
              maxLength: MAX_DESC_LENGTH,
            }}
          />
        </div>
      </div>

      <div>
        <div>
          <FieldTitle title={'Bullets'} optional />
        </div>
        <BulletsInput name={`sections.${index}.bullets`} />
      </div>
    </>
  );

  const secondCol = (
    <>
      <TwoColumns
        first={
          <ImageInput
            name={`sections.${index}.images.0.url`}
            control={control}
            upload={upload}
          />
        }
        second={
          <ImageInput
            name={`sections.${index}.images.1.url`}
            control={control}
            upload={upload}
          />
        }
      />

      <div>
        {/* <Controller
          name={`sections.${index}.rotateImages`}
          control={control}
          render={({ field: { value, onChange } }) => (
            <div className="flex space-x-3">
              <FieldDesc>Rotate Images: </FieldDesc>
              <Toggle value={value} onChange={onChange} />
            </div>
          )}
        /> */}
        {/* <SelectImageSideInput index={index} /> */}
      </div>

      <CTAFormComponent index={index} />
    </>
  );

  return <TwoColumns first={firstCol} second={secondCol} />;
};

function ImageInput({
  name,
  upload,
  control,
}: {
  name: string;
  upload: Props['upload'];
  control: any;
}) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
        <LandingMediaDropbox
          inputRef={ref}
          width="195px"
          height="422px"
          upload={upload}
          label="Image 1"
          validationText=""
          value={value}
          onChange={onChange}
          type="image"
          icon={faImage as any}
          errorMsg={error?.message}
          optional
        >
          <ul className="text-black list-none text-center text-h12">
            <li>390x844px image/gif, max 5MB</li>
          </ul>
        </LandingMediaDropbox>
      )}
    />
  );
}
